// Выпадающий список агентов, сгруппированный по направлениям.
import { useMemo } from 'react'
import { useLive } from '../store.ts'
import type { Agent } from '../types.ts'
import { cx } from './ui.tsx'

const TOP_KINDS = new Set(['orchestrator', 'reviewer', 'librarian'])

export function groupAgents(agents: Agent[], directions: { id: string; name: string }[]): { label: string; agents: Agent[] }[] {
  const active = agents.filter((a) => !a.archived)
  const groups: { label: string; agents: Agent[] }[] = []
  const top = active.filter((a) => TOP_KINDS.has(a.kind))
  if (top.length) groups.push({ label: 'Штаб и служебные', agents: top })
  for (const d of directions) {
    const list = active.filter((a) => !TOP_KINDS.has(a.kind) && a.direction_id === d.id)
    if (list.length) groups.push({ label: d.name, agents: list })
  }
  const known = new Set(directions.map((d) => d.id))
  const rest = active.filter((a) => !TOP_KINDS.has(a.kind) && (!a.direction_id || !known.has(a.direction_id)))
  if (rest.length) groups.push({ label: 'Без направления', agents: rest })
  for (const g of groups) {
    g.agents.sort((a, b) => (a.kind === 'lead' ? -1 : 0) - (b.kind === 'lead' ? -1 : 0) || a.name.localeCompare(b.name, 'ru'))
  }
  return groups
}

export function AgentSelect({
  value,
  onChange,
  emptyLabel,
  id,
  className,
  disabled,
  ariaLabel,
}: {
  value: string
  onChange: (v: string) => void
  emptyLabel?: string
  id?: string
  className?: string
  disabled?: boolean
  ariaLabel?: string
}) {
  const agents = useLive((s) => s.agents)
  const directions = useLive((s) => s.directions)
  const groups = useMemo(() => groupAgents(agents, directions), [agents, directions])
  const known = agents.some((a) => a.id === value)
  return (
    <select
      id={id}
      className={cx('ctl', className)}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {emptyLabel !== undefined ? <option value="">{emptyLabel}</option> : null}
      {value && !known ? <option value={value}>{value}</option> : null}
      {groups.map((g) => (
        <optgroup key={g.label} label={g.label}>
          {g.agents.map((a) => (
            <option key={a.id} value={a.id}>
              {a.name}
              {a.title ? ` — ${a.title}` : ''}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  )
}
